<template>
  <div>
    <b-card :style="{ backgroundColor: 'var(--bg-card)', color: 'var(--text-foreground)' }">
      <template #header>
        <h5 class="mb-0" style="color: var(--text-foreground);">
          <b-icon icon="diagram-3-fill" class="mr-2"/>Карта сети
        </h5>
      </template>

      <!-- DESIGN-4: Empty state -->
      <empty-state
        v-if="agents.length === 0"
        icon="diagram-3"
        title="Карта сети пуста"
        description="Установите агенты и привяжите их к сайтам для отображения сетевой карты"
      />

      <div v-if="agents.length > 0">
        <!-- Server node -->
        <div class="network-node server-node mb-3">
          <b-icon icon="server" font-scale="1.5"/>
          <strong class="ml-2">Fix Audit сервер</strong>
          <b-badge variant="info" class="ml-2">{{ serverUrl }}</b-badge>
        </div>

        <!-- Agent nodes grouped by site -->
        <div v-for="site in sitesWithAgents" :key="site.id" class="site-group mb-3">
          <div class="site-header">
            <b-icon icon="geo-fill" class="mr-1"/>
            <strong>{{ site.name }}</strong>
            <b-badge v-if="site.network" variant="secondary" class="ml-2">{{ site.network }}</b-badge>
            <b-badge variant="light" class="ml-1">{{ site.agents.length }} агентов</b-badge>
          </div>
          <div v-for="agent in site.agents" :key="agent.id" class="agent-node ml-4 mb-2">
            <span :class="['status-dot', agent.status === 'online' ? 'online' : 'offline']" class="mr-2"></span>
            <b-icon icon="pc-display" class="mr-1"/>
            <strong>{{ agent.name }}</strong>
            <small style="color: var(--text-muted);" class="ml-2">{{ agent.hostname || '—' }}</small>
            <b-badge :variant="agent.status === 'online' ? 'success' : 'danger'" class="ml-2">
              {{ agent.status === 'online' ? 'В сети' : 'Не в сети' }}
            </b-badge>
            <!-- Targets for this agent -->
            <div v-if="agent.targets && agent.targets.length > 0" class="ml-4 mt-1">
              <small style="color: var(--text-muted);">Цели:</small>
              <b-badge
                v-for="t in agent.targets"
                :key="t.id"
                :variant="typeVariant(t.type)"
                class="ml-1 mb-1"
              >{{ t.target }}</b-badge>
            </div>
          </div>
        </div>

        <!-- Agents without site -->
        <div v-if="unassignedAgents.length > 0" class="site-group mb-3">
          <div class="site-header">
            <b-icon icon="question-circle" class="mr-1"/>
            <strong>Без сайта</strong>
            <b-badge variant="warning" class="ml-2">{{ unassignedAgents.length }} агентов</b-badge>
          </div>
          <div v-for="agent in unassignedAgents" :key="agent.id" class="agent-node ml-4 mb-2">
            <span :class="['status-dot', agent.status === 'online' ? 'online' : 'offline']" class="mr-2"></span>
            <b-icon icon="pc-display" class="mr-1"/>
            <strong>{{ agent.name }}</strong>
            <small style="color: var(--text-muted);" class="ml-2">{{ agent.hostname || '—' }}</small>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi'
export default {
  name: 'networkMap',
  mixins: [RekonoApi],
  props: {
    project: Object
  },
  data () {
    this.fetchData()
    return {
      agents: [],
      sites: [],
      targets: [],
      serverUrl: window.location.origin
    }
  },
  computed: {
    sitesWithAgents () {
      return this.sites.filter(s => s.agents && s.agents.length > 0)
    },
    unassignedAgents () {
      return this.agents.filter(a => !a.site)
    }
  },
  methods: {
    fetchData () {
      this.get('/api/agents/', 1, 100).then(response => {
        this.agents = response.data.results
        this.fetchSites()
        if (this.project) {
          this.get('/api/targets/', 1, 100, { project: this.project.id }).then(r => {
            this.targets = r.data.results
            this.matchTargetsToAgents()
          })
        }
      })
    },
    fetchSites () {
      this.get('/api/sites/', 1, 100).then(response => {
        this.sites = response.data.results.map(site => ({
          ...site,
          agents: this.agents.filter(a => a.site === site.id)
        }))
      })
    },
    matchTargetsToAgents () {
      // Simple matching: if target.agent is set, assign
      this.agents.forEach((agent, i) => {
        this.agents[i].targets = this.targets.filter(t => t.agent === agent.id)
      })
    },
    typeVariant (type) {
      const map = {
        'Network': 'danger',
        'IP range': 'warning',
        'Private IP': 'info',
        'Public IP': 'primary',
        'Domain': 'success'
      }
      return map[type] || 'secondary'
    }
  }
}
</script>

<style scoped>
.network-node {
  padding: 12px;
  border-radius: 8px;
  border: 2px solid var(--border-default);
}
.server-node {
  background-color: var(--bg-muted);
  text-align: center;
}
.site-group {
  padding-left: 8px;
}
.site-header {
  padding: 8px 0;
  border-bottom: 1px solid var(--border-default);
  margin-bottom: 8px;
}
.agent-node {
  padding: 4px 0;
}
.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.status-dot.online {
  background-color: #22C55E;
  box-shadow: 0 0 4px #22C55E;
}
.status-dot.offline {
  background-color: #ef4444;
}
</style>